import moment from 'moment';

export function getNextChristmas() {
    const today = moment();
    const thisYearChristmas = moment({ year: today.year(), month: 11, day: 25 }); // December 25 of this year
    // If today is after Christmas this year, calculate for next year
    if (today.isAfter(thisYearChristmas)) {
        return thisYearChristmas.add(1, 'year').format('YYYY-MM-DDTHH:mm');
    }
    return thisYearChristmas.format('YYYY-MM-DDTHH:mm');
} 

export function getNextNewYear() {
    const today = moment();
    const thisNewYear = moment({ year: today.year(), month: 0, day: 1 }); // Jan 1 of this year
    // If today is after Christmas this year, calculate for next year
    if (today.isAfter(thisNewYear)) {
        return thisNewYear.add(1, 'year').format('YYYY-MM-DDTHH:mm');
    }
    return thisNewYear.format('YYYY-MM-DDTHH:mm');
}

export function getNextFridayAtFive() {
    const today = moment();
    let nextFriday = today.clone().day(5).hour(17).minute(0).second(0);
    // If today is Friday after 17:00, move to next week's Friday
    if (today.isAfter(nextFriday)) {
        nextFriday = nextFriday.add(1, 'week');
    }
    return nextFriday.format('YYYY-MM-DDTHH:mm');
}

export function getDrinkingTime() {
    const today = moment();

    if (today.day() === 6 || today.day() === 0) { // Saturday or Sunday
        const lastFriday = today.clone().day(-2).hour(17).minute(0).second(0); // Last Friday
        return lastFriday.format('YYYY-MM-DDTHH:mm');
    } else {
        const nextFriday = today.clone().day(5).hour(17).minute(0).second(0); // Next Friday
        if (today.isAfter(nextFriday)) {
            return nextFriday.add(1, 'week').format('YYYY-MM-DDTHH:mm');
        }
        return nextFriday.format('YYYY-MM-DDTHH:mm');
    }
}